import React, { Component } from 'react';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonItem,
  IonLabel,
  IonText,
  IonSelect,
  IonSelectOption,
  IonSpinner,
  withIonLifeCycle,
} from '@ionic/react';

import moment from 'moment';
import HeaderButtons from '../components/HeaderButtons';
import RentalCalendar from '../components/RentalCalendar';
import RentalPriceSummary from '../components/RentalPriceSummary';
import RentalDevicesService from '../services/rentalDevices';

class RentalDeviceDetails extends Component {
  constructor(props) {
    super(props);

    this.loader = React.createRef();

    this.state = {
      momentDate: moment(),
      device: null,
      loading: true,
      duration: 1,
    };
  }

  async ionViewWillEnter() {
    const { id } = this.props.match.params;

    this.setState({ loading: true });

    try {
      const { data: device } = await RentalDevicesService.findOne(id);
      this.setState({
        device,
        duration: device.min_days || 1,
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loading: false });
    }
  }

  // Il limite in avanti è la finestra di prenotazione del dispositivo: lo applica
  // RentalCalendar con window_end (piano 2026_09_25_110028, Parte 8), non un
  // numero fisso di mesi qui.
  handleNextMonth = () => {
    this.setState({ momentDate: this.state.momentDate.add(1, 'M') });
  };

  // Il calendario si apre sul mese del giorno da preselezionare (link del chatbot).
  goToMonth = (month) => {
    this.setState({ momentDate: month.clone().startOf('month') });
  };

  handlePrevMonth = () => {
    let momentClone = this.state.momentDate.clone().subtract(1, 'M');
    if (momentClone.format('YYMM') >= moment().format('YYMM')) {
      this.setState({ momentDate: this.state.momentDate.subtract(1, 'M') });
    }
  };

  render() {
    const { device, loading, momentDate, duration } = this.state;

    if (loading) {
      return (
        <>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonBackButton defaultHref="/app/rentals" />
              </IonButtons>
              <IonTitle>Dettaglio Dispositivo</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonContent>
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <IonSpinner />
            </div>
          </IonContent>
        </>
      );
    }

    if (!device) {
      return (
        <>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonBackButton defaultHref="/app/rentals" />
              </IonButtons>
              <IonTitle>Dispositivo non trovato</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonContent>
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Dispositivo non disponibile.</p>
            </div>
          </IonContent>
        </>
      );
    }

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/rentals" />
            </IonButtons>

            <HeaderButtons {...this.props} />
            <IonTitle>{device.name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {device.image_url && (
            <div className="ion-text-center">
              <img
                src={device.image_url}
                alt={device.name}
                style={{
                  width: '100%',
                  height: '220px',
                  objectFit: 'cover',
                }}
              />
            </div>
          )}

          <IonItem>
            <IonLabel>
              <h2>{device.name}</h2>
              {device.category_name && (
                <IonText color="medium">
                  <p>Categoria: {device.category_name}</p>
                </IonText>
              )}
            </IonLabel>

            {device.show_price !== false && (
              <IonText slot="end" color="primary">
                <h3>
                  <RentalPriceSummary device={device} emptyLabel="Gratuito" />
                </h3>
              </IonText>
            )}
          </IonItem>

          {device.description && (
            <div className="ion-padding" style={{ paddingTop: 0 }}>
              <IonText color="medium">
                <p>{device.description}</p>
              </IonText>
            </div>
          )}

          <div className="ion-padding-horizontal">
            <IonItem lines="none" style={{ '--background': 'transparent' }}>
              <IonLabel>
                <strong>Durata noleggio</strong>
                <p style={{ fontSize: '13px', color: 'var(--ion-color-medium)' }}>
                  {device.min_days && device.max_days
                    ? `Min ${device.min_days} - Max ${device.max_days} giorni`
                    : 'Seleziona la durata'}
                </p>
              </IonLabel>

              <IonSelect
                value={duration}
                slot="end"
                interface="action-sheet"
                onIonChange={(e) => this.setState({ duration: e.detail.value })}
              >
                {Array.from(
                  { length: (device.max_days || 30) - (device.min_days || 1) + 1 },
                  (_, i) => i + (device.min_days || 1)
                ).map((d) => (
                  <IonSelectOption key={d} value={d}>
                    {d} giorn{d > 1 ? 'i' : 'o'}
                  </IonSelectOption>
                ))}
              </IonSelect>
            </IonItem>
          </div>

          <div className="ion-padding-horizontal">
            <IonLabel>
              <h3 style={{ marginTop: '16px', marginBottom: '4px' }}>Seleziona giorno di ritiro</h3>
            </IonLabel>
          </div>

          <RentalCalendar
            momentDate={momentDate}
            deviceId={this.props.match.params.id}
            duration={duration}
            nextMonth={this.handleNextMonth}
            prevMonth={this.handlePrevMonth}
            goToMonth={this.goToMonth}
            {...this.props}
          />
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(RentalDeviceDetails);
